import { relation, field, children, date ,text} from '@nozbe/watermelondb/decorators';
import { SIGNATURES_SCHEMA } from '../schema';
import { Model } from '@nozbe/watermelondb';

export default class Signatures extends Model {
    static table = SIGNATURES_SCHEMA;

    static associations = {
        user: { type: 'belongs_to', key: 'user_id' },
        invoice: { type: 'has_many', foreignKey: 'signatures_id' },
    }

    @text('sign_url') sign_url;

    @date('created_at') created_at;
    @date('updated_at') updated_at;

    @relation('user', 'user_id') user;
    @children('invoice') invoice;
};